import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import resolveResponse from 'contentful-resolve-response'
import {FreeFormTemplate} from '../layouts'
import {Universe23WaitlistTemplate} from '../layouts/Universe23WaitlistTemplate'
import {type ContainerPage, toContainerPage, toEntryCollection} from '../lib/types/contentful'
import {toPayload} from '../lib/types/payload'

function getReactComponentFor<Page extends ContainerPage>(page: Page): React.ElementType {
  const map: Record<ContainerPage['fields']['template']['sys']['contentType']['sys']['id'], React.ElementType> = {
    templateFreeForm: FreeFormTemplate,
    templateUniverse23Waitlist: Universe23WaitlistTemplate,
  }

  return map[page.fields.template.sys.contentType.sys.id]
}

export const ShowPage = () => {
  const {contentfulRawJsonResponse, userLoggedIn} = toPayload(useRoutePayload<unknown>())
  const page = toContainerPage(toEntryCollection(resolveResponse(contentfulRawJsonResponse)).at(0))

  const PageComponent = getReactComponentFor(page)

  return <PageComponent page={page} userLoggedIn={userLoggedIn} />
}

try{ ShowPage.displayName ||= 'ShowPage' } catch {}
try{ PageComponent.displayName ||= 'PageComponent' } catch {}